import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/settings/profile/')({
	staticData: {
		crumb: ({ context: { L } }) => L.Settings.Profile.Title()
	}
})
